import { IsUUID } from "class-validator";

export default class TestTest {
  @IsUUID("4")
  public readonly id!: string;
}
